<template lang="pug">
span(v-if="voucher" @click.stop="openDetails" :class="details? 'is-clickable' : ''")
  span {{voucher.name}}
  template(v-if="code")
    |  ·  
    b {{voucher.code}}
  template(v-if="invoice")
    |  ·  
    span \#{{voucher.invoice}}
  template(v-if="showNominalValue")
    |  -      
    currency-view(:value="voucher.value" )
    template(v-if="showRemainder")
      |  (
      currency-view(:value="voucher.remaining")
      | )
span.button.is-loading.tag.px-4(v-else-if="loading")
span.has-text-grey(v-else) {{$t('vouchers.removed_voucher')}}

</template>
<script>
import VoucherDetails from './VoucherDetails'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'VoucherNameView',
  props: {
    value: {type: String, required: true},
    code: {type: Boolean, default: true},
    invoice: {type: Boolean, default: false},
    details: {type: Boolean, default: true},
    showNominalValue: {type: Boolean, default: false},
    showRemainder: {type: Boolean, default: false}
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('vouchers', ['vouchersMap']),
    voucher() {
      return this.vouchersMap[this.value]
    }
  },
  async created() {
    this.loading = true
    await this.getVoucherById({voucherId: this.value})
    this.loading = false
  },
  methods: {
    ...mapActions('vouchers', ['getVoucherById']),
    openDetails() {
      this.$buefy.modal.open({
        parent: this,
        width: 960,
        hasModalCard: true,
        fullScreen: this.isMobile(),
        props: {value: this.voucher._id},
        component: VoucherDetails,
        canCancel: ['outside', 'escape']
      })
    }
  }
}
</script>
